<div
    class="tenure-interests-notifications-modal"
    data-test-automation="tenure-interests-modal">
    <div
        id="myModal"
        role="dialog"
        class="modal fade in">
        <div class="backdrop"></div>
        <div
            data-show="true"
            role="document"
            class="modal-dialog modal-xlg">
            <div class="modal-content">
                <form
                    id="tenInNoModalForm"
                    #tenInNoModalForm="ngForm"
                    novalidate
                    autocomplete="off">
                    <div class="modal-header">
                        <button
                            type="button"
                            class="close"
                            (click)="dismissModal(tenInNoModalForm)"
                            title="Close"
                            aria-hidden="true">
                            <i class="nlrp-icon nlrp-icon-close"></i>
                        </button>
                        <h3 class="modal-title">{{ title }}</h3>
                    </div>
                    <div class="modal-body">
                        <div class="well">
                            <div class="row">
                                <div class="col-xs-12">
                                    <div class="row">
                                        <div class="col-xs-4">
                                            <label
                                                class="control-label"
                                                for="formerTenure"
                                                >{{getLabel('broughtForwardNotificationsTableParentTenureColumnLabel')}}</label
                                            >
                                            <div class="input-group">
                                                <input
                                                    type="text"
                                                    id="formerTenure"
                                                    name="formerTenure"
                                                    class="form-control"
                                                    value="{{tenureInterestNotification.identifier}}"
                                                    readonly
                                                    [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                                    data-test-automation="notification-identifier" />
                                            </div>
                                        </div>
                                        <div class="col-xs-4">
                                            <label
                                                class="control-label"
                                                [ngClass]="{'required-input': isOriginDocumentRequired()}"
                                                    for="originDocument"
                                                >{{getLabel('broughtForwardNotificationsOriginDocumentColumnLabel')}}</label
                                            >
                                            <div
                                                class="input-group"
                                                [ngClass]="{'has-error': originDocument.invalid && originDocument.dirty}">
                                                <input
                                                    type="text"
                                                    id="originDocument"
                                                    #originDocument="ngModel"
                                                    name="originDocument"
                                                    class="form-control"
                                                    [(ngModel)]="tenureInterestNotification.originDocument"
                                                    placeholder=""
                                                    nlrFocus
                                                    autocomplete="off"
                                                    (change)="originDocumentChanged(tenInNoModalForm)"
                                                    title="Enter origin document number"
                                                    [nlrPattern]="DOCUMENT_PATTERN"
                                                    [required]="isOriginDocumentRequired()"
                                                    [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions) || tenureInterestNotification.notificationDocument || !isOriginDocumentRequired()"
                                                    data-test-automation="origin-document-number" />
                                            </div>
                                            @if (originDocument.errors?.nlrPattern) {
                                                <div class="help-block">
                                                    <span>Error!</span>
                                                    <span>Incorrect entry, format should be document prefix and number e.g. M123456, T8606/1961</span>
                                                </div>
                                            }
                                            @if (originDocument.errors?.validIdentifier && originDocument.dirty) {
                                                <div class="help-block">
                                                    <span>Error!</span>
                                                    <span>{{ getFieldErrorMessage('originDocument') }}</span>
                                                </div>
                                            }
                                        </div>
                                        <div class="col-xs-4">
                                            <label
                                                class="control-label"
                                                [ngClass]="{'required-input': isOriginPlanRequired()}"
                                                for="originPlan"
                                                >Origin plan number</label
                                            >
                                            <div
                                                class="input-group"
                                                [ngClass]="{'has-error': originPlan | formFieldHasError}">
                                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                <input
                                                    type="text"
                                                    id="originPlan"
                                                    #originPlan="ngModel"
                                                    name="originPlan"
                                                    class="form-control"
                                                    [nlrPattern]="SURVEY_PATTERN"
                                                    [(ngModel)]="tenureInterestNotification.originPlan"
                                                    (change)="originPlanChanged(tenInNoModalForm)"
                                                    [required]="isOriginPlanRequired()"
                                                    [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                                    data-test-automation="origin-plan-number" />
                                            </div>
                                            @if (originPlan.errors?.nlrPattern) {
                                                <div class="help-block">
                                                    <span>Error!</span>
                                                    <span>Invalid identifier</span>
                                                </div>
                                            }
                                            @if (originPlan.errors?.validIdentifier && originPlan.dirty) {
                                                <div class="help-block">
                                                    <span>Error!</span>
                                                    <span>{{ getFieldErrorMessage('originPlan') }}</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <label
                                        class="control-label"
                                        for="endorsementComments"
                                        >{{getLabel('broughtForwardNotificationsTableEndorsementColumnLabel')}}</label
                                    >
                                    <div class="input-group">
                                        <textarea
                                            class="form-control"
                                            name="endorsementComments"
                                            id="endorsementComments"
                                            placeholder="Enter endorsement"
                                            rows="2"
                                            cols="50"
                                            [ngModel]="tenureInterestNotification.endorsement"
                                            title="Enter a comment related to Former Tenure Interests and Notifications"
                                            readonly
                                            [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                            data-test-automation="endorsement">
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                            @if (statutoryReferenceOptions.length) {
                                <div class="row">
                                    <div class="col-xs-4">
                                        <label
                                            class="control-label required-input"
                                            for="statutoryReference"
                                            >Statutory reference</label
                                        >
                                        <div class="input-group">
                                            <ng-select
                                                class="nlr-ng-select"
                                                #statutoryReference="ngModel"
                                                [searchable]="false"
                                                [clearable]="false"
                                                [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                                name="statutoryReference"
                                                id="statutoryReference"
                                                placeholder="Select"
                                                [items]="statutoryReferenceOptions"
                                                bindLabel="actAndRegulation"
                                                bindValue="notificationCode"
                                                [(ngModel)]="tenureInterestNotification.notificationCodeOverride"
                                                required>
                                            </ng-select>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div class="well">
                            <div class="row">
                                <div class="col-xs-4">
                                    <label
                                        class="control-label required-input"
                                        >{{getLabel('broughtForwardNotificationsTableActionColumnLabel')}}</label
                                    >
                                    <div
                                        class="input-group"
                                        data-test-automation="treatment-action">
                                        @for (option of filteredNotificationTreatmentActionLookups(); track option; let i = $index) {
                                            <div>
                                                <label class="nlr-radio">
                                                    <input
                                                        type="radio"
                                                        name="burdenAction{{i}}"
                                                        #burdenAction="ngModel"
                                                        [value]="option.id"
                                                        [ngModel]="tenureInterestNotification.treatmentAction?.id"
                                                        (change)="treatmentActionUpdated(option.id)"
                                                        required
                                                        data-test-automation="treatment-action-option-{{option.id}}" />
                                                    <span title="{{option.tooltip}}">{{option.description}}</span>
                                                </label>
                                                @if (
                                                    actionPdfCreationMethodInvalidForPlan() && option.id === tenureInterestNotification.treatmentAction?.id
                                                ) {
                                                    <i
                                                        class="nlrp-icon nlrp-icon-error error"
                                                        title="{{unsupportedMessage()}}"></i>
                                                }
                                            </div>
                                        }
                                    </div>
                                    @if (burdenActionHasError()) {
                                        <div class="help-block">
                                            <span>Error!</span>
                                            <span>Please select action.</span>
                                        </div>
                                    }
                                </div>
                                @if (showSubjectForAction) {
                                    <div class="col-xs-8">
                                        <div class="row">
                                            @for (intSubject of tenureInterestNotification.subjects; track intSubject; let i = $index) {
                                                <div data-test-automation="subject">
                                                    <div class="row">
                                                        <div class="col-xs-6">
                                                            <label class="control-label">{{intSubject.subjectType.fieldLabel}}</label>
                                                            <div
                                                                class="input-group"
                                                                [ngClass]="{'has-error': subject | formFieldHasError}">
                                                                <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                                <input
                                                                    #subject="ngModel"
                                                                    type="text"
                                                                    name="subject{{i}}"
                                                                    id="subject{{i}}"
                                                                    class="form-control"
                                                                    [(ngModel)]="intSubject.subject"
                                                                    [nlrPattern]="ALPHANUMERIC_PATTERN"
                                                                    placeholder=""
                                                                    nlrFocus
                                                                    autocomplete="off"
                                                                    [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                                                    data-test-automation="subject" />
                                                            </div>
                                                            @if (isDuplicateSubject(intSubject, i)) {
                                                                <div class="help-block">
                                                                    <span>Error!</span>
                                                                    <span>Subject has already been used</span>
                                                                </div>
                                                            }
                                                            @if (subject?.errors?.nlrPattern) {
                                                                <div class="help-block">
                                                                    <span>Error!</span>
                                                                    <span
                                                                        >Invalid character/s. The following characters are permitted: A-Z, a-z, 0-9, (
                                                                        ) - / and Space</span
                                                                    >
                                                                </div>
                                                            }
                                                        </div>
                                                        @if (intSubject.subjectType.operativePortion && showAffectedLots(i)) {
                                                            <div class="col-xs-6">
                                                                @for (
                                                                    burdenAffectedLot of intSubject.affectedLots;
                                                                    track burdenAffectedLot;
                                                                    let i = $index
                                                                ) {
                                                                    <div data-test-automation="burden-affected-lot">
                                                                        @if (i === 0) {
                                                                            <label
                                                                                class="control-label required-input"
                                                                                for="burdenAffectedLot{{i}}">
                                                                                {{getLabel('broughtForwardNotificationsNewTenureFieldLabel')}}
                                                                            </label>
                                                                        }
                                                                        <div
                                                                            class="input-group"
                                                                            [ngClass]="{'has-error': burdenAffectedLotHasError(i)}">
                                                                            <span class="input-group-addon"
                                                                                ><i class="nlrp-icon nlrp-icon-edit"></i
                                                                            ></span>
                                                                            <input
                                                                                type="text"
                                                                                class="form-control"
                                                                                name="burdenAffectedLot{{i}}"
                                                                                id="burdenAffectedLot{{i}}"
                                                                                #burdenAffectedLotModel="ngModel"
                                                                                placeholder="Enter Affected Lot Number or Lot Range"
                                                                                title="Enter or modify the Affected Lot(s)"
                                                                                maxlength="20"
                                                                                [ngModel]="getBurdenAffectedLotForDisplay(burdenAffectedLot)"
                                                                                (ngModelChange)="onChangeAffectedLot(intSubject, i, $event)"
                                                                                [nlrPattern]="LOT_PATTERN"
                                                                                [disabled]="((['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions) || readOnly())"
                                                                                data-test-automation="lot"
                                                                                required />
                                                                            @if (!readOnly()) {
                                                                                <span class="input-group-addon">
                                                                                    <i
                                                                                        class="nlrp-icon nlrp-icon-add"
                                                                                        tabindex="0"
                                                                                        (click)="addLotRecord(intSubject)"
                                                                                        title="Add additional field record number"
                                                                                        data-test-automation="add-lot"></i>
                                                                                </span>
                                                                            }
                                                                            @if (i > 0 && !readOnly()) {
                                                                                <span class="input-group-addon">
                                                                                    <i
                                                                                        class="nlrp-icon nlrp-icon-remove"
                                                                                        tabindex="0"
                                                                                        (click)="removeLotRecord(intSubject, burdenAffectedLot)"
                                                                                        title="Delete the field record number"
                                                                                        data-test-automation="remove-lot"></i>
                                                                                </span>
                                                                            }
                                                                        </div>
                                                                        @if (burdenAffectedLotModel?.errors?.nlrPattern) {
                                                                            <div class="help-block">
                                                                                <span>Error!</span>
                                                                                <span>Lot has to be a number N or a number range N-N.</span>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                        <div
                                            class="row"
                                            style="margin-top: 1.5em;">
                                            @if (currentDocumentLabel) {
                                                <div class="col-xs-4">
                                                    <div class="row">
                                                        <label
                                                            for
                                                            class="control-label"
                                                            >{{currentDocumentLabel}}</label
                                                        >
                                                        <div
                                                            class="input-group"
                                                            [class]="{'has-error': treatmentDocument | formFieldHasError}">
                                                            <span class="input-group-addon"><i class="nlrp-icon nlrp-icon-edit"></i></span>
                                                            <input
                                                                type="text"
                                                                id="treatmentDocument"
                                                                name="treatmentDocument"
                                                                #treatmentDocument="ngModel"
                                                                class="form-control"
                                                                [(ngModel)]="tenureInterestNotification.treatmentDocument"
                                                                placeholder=""
                                                                [nlrPattern]="DOCUMENT_PATTERN"
                                                                autocomplete="off"
                                                                (change)="treatmentDocumentChanged(tenInNoModalForm)"
                                                                [disabled]="(['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions)"
                                                                data-test-automation="treatment-document" />
                                                        </div>
                                                        @if (treatmentDocument?.errors?.nlrPattern) {
                                                            <div class="help-block">
                                                                <span>Error!</span>
                                                                <span
                                                                    >Incorrect entry, format should be document prefix and number e.g. M123456,
                                                                    T8606/1961</span
                                                                >
                                                            </div>
                                                        }
                                                        @if (treatmentDocument?.errors?.validIdentifier && treatmentDocument?.dirty) {
                                                            <div class="help-block">
                                                                <span>Error!</span>
                                                                <span>{{ getFieldErrorMessage('treatmentDocument') }}</span>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        @if (tenureInterestNotification.treatmentAction?.commentFieldLabel) {
                            <div class="well">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <label
                                            class="control-label"
                                            for="generalComments"
                                            >{{tenureInterestNotification.treatmentAction.commentFieldLabel}}</label
                                        >
                                        <div class="input-group">
                                            <span class="input-group-addon corner"><i class="nlrp-icon nlrp-icon-edit corner-icon"></i></span>
                                            <textarea
                                                class="form-control"
                                                name="generalComments"
                                                id="generalComments"
                                                placeholder="Comments"
                                                rows="2"
                                                cols="50"
                                                maxlength="255"
                                                [(ngModel)]="tenureInterestNotification.comments"
                                                title="Enter a comment related to Former Tenure Interests and Notifications"
                                                [disabled]="((['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions) || readOnly())"
                                                data-test-automation="comments">
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                    <div class="modal-footer">
                        <div class="row buttons">
                            <div class="button-group">
                                <button
                                    type="button"
                                    id="saveIntrBtn"
                                    [disabled]="tenInNoModalForm.invalid || (['EDIT_INTERESTS', 'VIEW_INTERESTS'] | disabledByPermissions) || readOnly()"
                                    class="btn btn-default nlr-btn-sm"
                                    (click)="save()"
                                    title="Save the former tenure interests/notification"
                                    data-test-automation="save-interests">
                                    Save
                                </button>
                                <button
                                    type="button"
                                    id="cancelIntrBtn"
                                    class="btn btn-warning nlr-btn-sm"
                                    (click)="dismissModal(tenInNoModalForm)"
                                    title="Close the edit  former tenure interests/notification screen without saving"
                                    data-test-automation="cancel-interests">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
